import "core-js/modules/es.array.map.js";
import React from 'react';
import PropTypes from 'prop-types';
import { stepperContainer, stepItem, stepConnector } from './styles';
import { jsx as ___EmotionJSX } from "@emotion/react";

var StepProgress = function StepProgress(_ref) {
  var steps = _ref.steps,
      activeStep = _ref.activeStep,
      onStepClick = _ref.onStepClick;
  return ___EmotionJSX("nav", {
    css: stepperContainer
  }, steps.map(function (step, index) {
    var stepNumber = index + 1;
    var isActive = stepNumber === activeStep;
    var isCompleted = stepNumber < activeStep;
    return ___EmotionJSX(React.Fragment, {
      key: step.key
    }, index > 0 && ___EmotionJSX("div", {
      css: stepConnector(isCompleted)
    }), ___EmotionJSX("div", {
      css: stepItem(isActive, isCompleted),
      role: "button",
      tabIndex: "0",
      onClick: function onClick() {
        return isCompleted && (onStepClick === null || onStepClick === void 0 ? void 0 : onStepClick(stepNumber));
      }
    }, ___EmotionJSX("span", {
      className: "step-circle"
    }, isCompleted ? ___EmotionJSX("i", {
      className: "las la-check"
    }) : stepNumber), ___EmotionJSX("span", {
      className: "step-label"
    }, step.label)));
  }));
};

StepProgress.propTypes = {
  steps: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired
  })).isRequired,
  activeStep: PropTypes.number.isRequired,
  onStepClick: PropTypes.func
};
export default StepProgress;